import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {ApolloQueryObservable} from "apollo-angular";
import {FetchExpiringStocksQuery} from "../../../../shared/graphql/graphql.types";
import {StockService} from "../../../services/stock.service";
import {BehaviorSubject} from "rxjs/BehaviorSubject";
import {Stock} from "../../../../shared/view-model/stock";
import {environment} from "../../../../../environments/environment";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {FormBuilder, FormControl} from "@angular/forms";
import {GenericModalComponent} from "../../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";

@Component({
  selector: 'vb-check-product-batches-view',
  templateUrl: './check-product-batches-view.component.html',
  styleUrls: ['./check-product-batches-view.component.css']
})
export class CheckProductBatchesViewComponent extends AbstractVisbosComponent implements OnInit {

  private expiringStocks$: ApolloQueryObservable<FetchExpiringStocksQuery>;
  public expiringStocks: Stock[];

  searchTerm: FormControl;
  ubdDateFilter$: BehaviorSubject<number> = new BehaviorSubject<number>(environment.view.ubd_range_in_days);

  @ViewChild('searchBatchesModal')
  searchBatchesModal: GenericModalComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef, private fb: FormBuilder,
              private stockService: StockService) {

    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Suche nach Chargen',
        icon: 'fa-search',
        action: () => this.searchForLOTClicked.apply(this),
        helpText: 'Suche nach Chargen am Standort'
      }
    ]

  }

  ngOnInit(): void {

    super.ngOnInit();

    this.searchTerm = this.fb.control(null);

    const days$ = this.ubdDateFilter$.pipe(
      debounceTime(1000),
      distinctUntilChanged()
    );

    this.expiringStocks$ = this.stockService.fetchExpiringStocks(null, null, null, null, days$);
    this.addComponentData(this.expiringStocks$);
    this.addSubscription(this.expiringStocks$.subscribe(res => {
      this.loadingIndicators.set('expiringStocks', res.loading);
      this.expiringStocks = res.data.expiringStocks;
    }));
    this.loadingIndicators.set('expiringStocks', true);
  }

  searchForLOTClicked() {
    this.searchBatchesModal.show();
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/views/check-product-batches-view/check-product-batches-view.component.ts